import {
  ResourceBaseNameInterface,
  ResourceBaseNumberOptionInterface,
  ResourceBaseSubjectInterface,
} from 'src/editor/shared/types/resources-interface'

export const getResourceBaseNameOptions = (
  data: ResourceBaseNameInterface[],
) => {
  const options: ResourceBaseNumberOptionInterface[] = data.map(resource => {
    return {
      label: resource.name,
      value: resource.id,
    }
  })
  return options
}

export const getResourceBaseSubjectOptions = (
  data: ResourceBaseSubjectInterface[],
) => {
  const options: ResourceBaseNumberOptionInterface[] = data.map(resource => {
    return {
      label: resource.subject,
      value: resource.id,
    }
  })
  return options
}
